import React from 'react'
import MainCard from '../../components/MainCard'
import { Box, Paper } from '@mui/material'

export default function Wrapper({ children, ...other }) {
  return (
   <>
    <Paper
    elevation={3} 
    sx={{
      maxWidth: { xs: 400, lg: 550 },
      margin: { xs: 2.5, md: 1 },
      '& > *': {
        flexGrow: 1,
        flexBasis: '50%'
      },
      borderRadius:'24px'
    }}
    content={false}
    {...other}
  >
    <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
  </Paper>
   </>
  )
}
